import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import BreadCumb from "../component/BreadCumb";
import {Helmet} from "react-helmet-async";

const VisaByType  = () => {
    const { slug } = useParams();
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [visaByTypes,setVisaByTypes] = useState([]);
    useEffect(() => {
        console.log("useEffect:", slug);
        if (!slug) return;
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_TYPE;
        axios.get(`${apiBaseUrl}${Url}/${slug}`)
            .then(response => setVisaByTypes(response.data))
            .catch(error => console.error("Error fetching API", error));
    }, [slug]);

    return (
        <>
            <Helmet>
                <title>Tarif Overseas Ltd. | Visa</title>
                <meta name="description" content="Tarif Overseas Ltd. is a trusted overseas recruitment agency in Bangladesh providing professional manpower recruitment services."/>
                <link rel="canonical" href={`https://tarifoverseasltd.com/visa/${slug}`}/>
            </Helmet>
            <main className="main">
            {/*<BreadCumb image="visa_services.webp" />*/}
            <div className="visa-area pt-60 pb-80">
                <div className="container">
                    <div className="visa-wrap wow fadeInUp" data-wow-delay=".25s">
                        <div className="row g-4">
                            {visaByTypes?.visas?.length > 0 ? (
                                visaByTypes.visas.map((visaByType, index) => (
                                    <div className="col-md-6 col-lg-3" key={index}>
                                        <Link className="text-decoration-none" to={`/visa/details/${visaByType.slug}`}>
                                            <div className="card feature-item">
                                                <div className="card-header d-grid justify-content-center">
                                                    <div>
                                                        <img src={`${backendBaseUrl}${visaByType?.image}`} alt="" />
                                                    </div>
                                                </div>
                                                <div className="card-body">
                                                    <div className="feature-content">
                                                        <h6 className="text-center fw-bold">{visaByType?.name}</h6>
                                                        <p align="justify">
                                                            <small>{visaByType?.short_description}</small>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center">
                                    <p>No data found</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </main>
        </>
    );
};

export default VisaByType;